import React from 'react';
import cx from 'classnames';
import { useMediaQuery, Theme } from '@material-ui/core';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import CancelIcon from '@material-ui/icons/Cancel';
import { useSamplePhotoStyles } from './useSamplePhotoStyles';

export enum SAMPLE_PHOTO_TYPE_ENUM {
  WRONG = 'wrong',
  CORRECT = 'correct',
}

interface ISamplePhoto {
  url: string;
  type: SAMPLE_PHOTO_TYPE_ENUM;
  numberOfSamples: number;
}

const SamplePhoto: React.FC<ISamplePhoto> = ({ url, type, numberOfSamples }) => {
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
  const classes = useSamplePhotoStyles(isMobileView, numberOfSamples, url)();
  return (
    <div className={cx(classes.root, classes[type])}>
      <div className={classes.image} />
      {/* {type === SAMPLE_PHOTO_TYPE_ENUM.WRONG ? (
        <CancelIcon className={cx(classes.icon, classes.wrongIcon)} />
      ) : (
        <CheckCircleIcon className={cx(classes.icon, classes.correctIcon)} />
      )} */}
    </div>
  );
};

export default SamplePhoto;
